module.exports = __webpack_public_path__ + "img/bg2.1ab0041c.jpg";